import React from 'react';
import { ClickAppIcon, PaymeIcon, UzumBankIcon } from 'icons';
import { useTranslations } from 'next-intl';

import { useAppDispatch, useAppSelector } from 'store';

import { openAuthModal } from 'modules/auth';
import { setPaymentModal } from 'modules/lesson-detail';

interface IProps {
  price?: number;
  discountPrice?: number;
}

export const Payment = ({ price }: IProps) => {
  const t = useTranslations();
  const dispatch = useAppDispatch();
  const isAuth = useAppSelector(({ user }) => user?.phone);

  const onOpenPaymentModal = () => {
    if (!isAuth) {
      return dispatch(openAuthModal());
    }
    return dispatch(setPaymentModal(true));
  };

  return (
    <div className="rounded-xl bg-white p-3">
      <p className="font-medium">{t('tolov_qiling_va_davom_eting')}!</p>

      <div className="mt-3 rounded-xl bg-gray-50 p-3">
        <div className="flex flex-col items-start justify-between sm:flex-row sm:items-center">
          <div>
            <p className="text-xs font-medium">{t('kurs_narxi')}:</p>
              <span className="font-bold text-green-500">
                {price?.toLocaleString('ru')} {t('sum')}
              </span>
        
          </div>
          <div className="mt-3 flex items-center gap-3 sm:mt-0">
            <PaymeIcon className="w-13 h-4" />
            <ClickAppIcon className="w-13 h-4" />
            <UzumBankIcon className="w-13 h-4" />
          </div>
        </div>
        <button
          onClick={onOpenPaymentModal}
          className="shadow-gray-md h-11.5 mt-4 w-full cursor-pointer rounded-xl bg-gray-800 font-medium text-white transition-all duration-300 ease-in-out active:translate-y-1 active:shadow-none"
        >
          {t('xarid_qilish')}
        </button>
      </div>
    </div>
  );
};
